import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AssetReviewService } from '../asset-review/asset-review.service';
import { StoreService } from '../../../core/store/store.service';
import { Store } from '../../../core/models';

import { catchError, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ShapeService } from 'src/app/core/depot/shape.service';
import { toAnalyticsPanelInputs } from '../asset-review/grade-record.adapter';
import { StoreGradeRecord, StoreGradeResponse } from '../asset-review/store-grade.model';
import { SearchIntersectingShapeRequest } from 'src/app/core/depot/search-intersecting-shape-request';
import { SpatialShapeType } from 'src/app/core/depot/spatial-shape-type.enum';

interface StorePerformanceData {
  salesTotalPerformance: {
    vsTradeAreaSalesAverage: number;
    vsBannerMarketSalesAverage: number;
    vsMarketSalesAverage: number;
    annualSalesTotal: number;
    salesTotalGrade: string;
    salesIndexScore: number;
  };
  salesPerSqftPerformance: {
    vsTradeAreaSalesPerSqftAverage: number;
    vsBannerMarketSalesPerSqftAverage: number;
    vsMarketSalesPerSqftAverage: number;
    annualSalesPerSqft: number;
    salesPerSqftGrade: string;
    salesPerSqftIndexScore: number;
  };
  driveTimeMinutes : number
}

@Component({
  standalone: false,
  selector: 'mtn-analytics-review-full-page',
  templateUrl: './analytics-review-full-page.component.html',
  styleUrls: ['./analytics-review-full-page.component.scss']
})
export class AnalyticsReviewFullPageComponent implements OnInit {
  isExpandedView = true;
  uuid: string;
  banneruuid: string;
  point: any = {};
  cbsa: String;
  fips: string;
  assetReviewStoreDetails: any = {};
  realEstateQualityData: any = {};

  /** The stored record this page is showing, when it came from the grade API. */
  gradeRecord: StoreGradeRecord | null = null;
  bannerStrengthData: any = {};
  gradeBreakdownData: any = {};
  competitiveImpactData: any = {};
  analyticsData: any = {};
  storePerformanceData: StorePerformanceData;
  store: Store;
  dataValidation = false;
  loadingdataValidation = 0;
  private geometry: any;

  // Loading states
  isAnalyticsLoading: boolean = false;
  isAnalyticsDataLoading: boolean = false;
  analyticsLoadingProgress: number = 0;
  hasAnalyticsError: boolean = false;
  totalAnalyticsApis = 6; // 6 APIs: store details, real estate, banner strength, store performance, competitive impact, final grade
  apiCompletionStatus = {
    storeDetails: false,
    realEstate: false,
    bannerStrength: false,
    storePerformance: false,
    competitiveImpact: false,
    finalGrade: false
  };
  apiFailureStatus = {
    storeDetails: false,
    realEstate: false,
    bannerStrength: false,
    storePerformance: false,
    competitiveImpact: false,
    finalGrade: false
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private assetReviewService: AssetReviewService,
    private storeService: StoreService,
    private shapeService: ShapeService
  ) {
    console.log("---------const-----");
  }

  ngOnInit() {
    this.subscribeToRouteChanges();
  }

  private subscribeToRouteChanges(): void {
    this.route.params.subscribe((value: any) => {
      if (this.uuid !== value['uuid']) {
        this.uuid = value['uuid'];

        // Reset all error and loading states for new store
        this.resetAllStates();

        this.storeService.findOne(this.uuid)
          .pipe(
            catchError(error => {
              console.error('Error loading store:', error);
              this.hasAnalyticsError = true;
              return of(null);
            })
          )
          .subscribe((store: Store) => {
            if (store) {
              this.store = store;
              this.banneruuid = store.banner.uuid;
              this.point = store.space.location.point.features[0].geometry;
              this.initializeAnalyticsData();
              this.loadStoredGrade();
            }
          });
      }
    });
  }
private simulateProgress(target: number, duration: number): void {
  const stepTime = 100; // ms interval
  const steps = duration / stepTime;
  const increment = (target - (this.loadingdataValidation || 0)) / steps;

  let currentStep = 0;

  const intervalId = setInterval(() => {
    if (this.loadingdataValidation >= target || currentStep >= steps) {
      clearInterval(intervalId);
    } else {
      this.loadingdataValidation += increment;
      currentStep++;
    }
  }, stepTime);
}
  loadshapeData(){
    // Reset error states when starting shape data loading
    this.hasAnalyticsError = false;
    this.dataValidation = false;
    this.isAnalyticsDataLoading = true;
    this.loadingdataValidation = 0;
    this.simulateProgress(95,4000)
       const request: SearchIntersectingShapeRequest = {
      latitude: this.point.coordinates[1],
      longitude: this.point.coordinates[0],
      type: SpatialShapeType.CBSA
    };

    // Load store details immediately before validation to show data quickly
        // Check if already cached to avoid unnecessary API calls
        if (!this.assetReviewService.isStoreDetailsCached(this.uuid)) {
          this.loadAssetReviewStoreDetails(true);
        } else {
          // Load from cache immediately
          this.assetReviewService.assetReviewStoreDetails(this.uuid, false)
            .subscribe(result => {
              if (result) {
                this.assetReviewStoreDetails = result;
                this.apiCompletionStatus.storeDetails = true;
              }
            });
        }

  this.shapeService.searchIntersectingShape(request)
      .pipe(
        switchMap(intersectingShape => {
          // 🧠 CASE 1: API returned null or undefined — stop further calls
          if (!intersectingShape) {
            console.warn('⚠️ ShapeService returned null — skipping validation.');
            this.loadingdataValidation = 100;
            this.dataValidation = false;
            this.isAnalyticsLoading = false;
            this.isAnalyticsDataLoading = false;
            return of(null);
          }



          // 🧠 CASE 2: API returned empty array — proceed but with defaults
          if (intersectingShape?.features?.length > 0) {
            this.fips = intersectingShape.features[0].id;
            this.geometry = intersectingShape.features[0].geometry;
            this.cbsa = intersectingShape.features[0].properties?.name;
            // ✅ Continue user tracking regardless of shape response

          } else {
            console.warn('No intersecting shape found — proceeding with defaults.');
            this.fips = null;
            this.geometry = null;
            this.cbsa = null;
             this.loadingdataValidation = 100;
            this.dataValidation = false;
            this.isAnalyticsLoading = false;
            this.isAnalyticsDataLoading = false;

            return of(null);


          }


          // ✅ Only call validation if shapeService returned a valid response (even empty features)
          const storeDataValidationRequest = {
            point: { lat: this.point.coordinates[1], lng: this.point.coordinates[0] },
            travelTimeMinutes: 7,
            locationUuid: null,
            fips: this.fips // may be null
          };

          console.log("---------------fips = ", this.fips);

          return this.assetReviewService.assetReviewDataValidation(this.uuid, storeDataValidationRequest, false)
            .pipe(
              tap(response => {
                this.loadingdataValidation = 100;
                if (response && response.marketAreaCoveragePercentage > 55 && response.tradeAreaCoveragePercentage > 70) {
                  this.dataValidation = true;
                  this.loadAnalyticsData();
                } else {
                  this.dataValidation = false;
                  this.isAnalyticsLoading = false;
                  this.isAnalyticsDataLoading = false;
                }
              }),
              catchError(error => {
                console.log("🚀 ~ loadshapeData ~ error:", error);
                this.loadingdataValidation = 100;
                this.isAnalyticsLoading = false;
                this.isAnalyticsDataLoading = false;
                this.dataValidation = false;
                return of(null);
              })
            );
        }),
        catchError(error => {
          console.error('Error loading banner strength:', error);
          this.hasAnalyticsError = true;
          this.apiFailureStatus.bannerStrength = true;
          return of(null);
        })
      )
      .subscribe(result => console.log("🚀 ~ result:", result));

  }

  private loadAnalyticsData(): void {
    // Reset all error and loading states
    this.isAnalyticsLoading = true;
    this.isAnalyticsDataLoading = true;
    this.analyticsLoadingProgress = 0;
    this.hasAnalyticsError = false;

    // Reset API states
    this.resetApiCompletionStatus();
    this.apiFailureStatus = {
      storeDetails: false,
      realEstate: false,
      bannerStrength: false,
      storePerformance: false,
      competitiveImpact: false,
      finalGrade: false
    };

    // Clear previous store data
    this.assetReviewStoreDetails = {};
    this.realEstateQualityData = {};
    this.bannerStrengthData = {};
    this.competitiveImpactData = {};
    this.storePerformanceData = null;
    this.analyticsData.overallGrade = null;

    // Load all analytics APIs (use cache if available)
    this.loadAssetReviewStoreDetails(false);
    this.loadAssetReviewRealEstateQuality(false);
    this.loadBannerStrength(false);
    this.loadStorePerformance(false);
    this.loadCompetitiveImpact(false);
  }

  private retryFailedApis(): void {
    // Reset all completion status to prevent using stale data
    this.apiCompletionStatus = {
      storeDetails: false,
      realEstate: false,
      bannerStrength: false,
      storePerformance: false,
      competitiveImpact: false,
      finalGrade: false
    };

    // Clear all data to prevent contamination
    this.assetReviewStoreDetails = {};
    this.realEstateQualityData = {};
    this.bannerStrengthData = {};
    this.competitiveImpactData = {};
    this.storePerformanceData = null;
    this.analyticsData.overallGrade = null;

    // Reset failure status and start fresh
    this.apiFailureStatus = {
      storeDetails: false,
      realEstate: false,
      bannerStrength: false,
      storePerformance: false,
      competitiveImpact: false,
      finalGrade: false
    };

    this.hasAnalyticsError = false;
    this.isAnalyticsLoading = true;
    this.isAnalyticsDataLoading = true;
    this.analyticsLoadingProgress = 0;

    // Load all APIs fresh
    this.loadAssetReviewStoreDetails(true);
    this.loadAssetReviewRealEstateQuality(true);
    this.loadBannerStrength(true);
    this.loadStorePerformance(true);
    this.loadCompetitiveImpact(true);
  }

  private resetApiCompletionStatus(): void {
    this.apiCompletionStatus = {
      storeDetails: false,
      realEstate: false,
      bannerStrength: false,
      storePerformance: false,
      competitiveImpact: false,
      finalGrade: false
    };
  }

  private loadAssetReviewStoreDetails(forceRefresh: boolean = false): void {
    this.assetReviewService.assetReviewStoreDetails(this.uuid, forceRefresh)
      .pipe(
        catchError(error => {
          console.error('Error loading store details:', error);
          this.hasAnalyticsError = true;
          this.apiFailureStatus.storeDetails = true;
          return of(null);
        })
      )
      .subscribe((result: any) => {
        if (result) {
          this.assetReviewStoreDetails = result;
          this.stampRecordReportDate();
        }
        this.apiCompletionStatus.storeDetails = true;
        this.updateLoadingProgress();
        console.log("Analytics Full Page - Store Details:", result);
      });
  }

  private loadAssetReviewRealEstateQuality(forceRefresh: boolean = false): void {
    this.assetReviewService.assetReviewRealEstateQuality(this.uuid, forceRefresh)
      .pipe(
        catchError(error => {
          console.error('Error fetching real estate quality data:', error);
          this.hasAnalyticsError = true;
          this.apiFailureStatus.realEstate = true;
          return of({});
        })
      )
      .subscribe((result: any) => {
        if (result) {
          this.realEstateQualityData = {
            accessibility: result?.accessibility,
            parking: result?.parking,
            visibility: result?.visibility,
            trafficFlow: result?.trafficFlow,
            scCondition: result?.scCondition,
            grade: result?.realEstateGrade,
            realEstateScore: result?.realEstateScore || 0
          };
        }
        this.apiCompletionStatus.realEstate = true;
        this.updateLoadingProgress();
        console.log('🚀 Real Estate Quality Data:', this.realEstateQualityData);
      });
  }

 private loadBannerStrength(forceRefresh: boolean = false): void {
   if (!this.point || !this.geometry) {
     console.warn('Cannot load banner strength: missing point or geometry.');
     return;
   }

   // Optional: set fips if not already set
   if (!this.fips) {
     console.warn('FIPS is not set. Make sure to provide it.');
   }

   this.assetReviewService
     .assetReviewBannerStrength(this.uuid, this.banneruuid, this.point, this.geometry, forceRefresh)
     .pipe(
       catchError(error => {
         console.error('Error loading banner strength:', error);
         this.hasAnalyticsError = true;
         this.apiFailureStatus.bannerStrength = true;
         return of(null);
       })
     )
     .subscribe(result => {
       if (result) {
         this.bannerStrengthData = {
           creditRating: result.creditRating,
           networkStabillity: result.networkStabillity,
           marketPresence: result.marketPresence,
           grade: result.bannerStrengthGrade || 'N/A',
           bannerStrengthScore: result.bannerStrengthScore || 0
         };
       }
       this.apiCompletionStatus.bannerStrength = true;
       this.updateLoadingProgress();
     });
 }



  private loadStorePerformance(forceRefresh: boolean = false): void {
    // Prepare the request data for store performance
    const storePerformanceRequest = {
      point: {
        lat: this.point.coordinates[1],
        lng: this.point.coordinates[0]
      },
      travelTimeMinutes: 7,
      locationUuid: null,
      comparisonType: "BANNER",
      bannerUuid: this.banneruuid,
      fips: this.fips,
      fit: this.assetReviewStoreDetails.fit
    };

    console.log("---------------fips = ", this.fips);
    this.assetReviewService.assetReviewStorePerformance(this.uuid, storePerformanceRequest, forceRefresh)
      .pipe(
        catchError(error => {
          console.error('Error loading store performance:', error);
          this.hasAnalyticsError = true;
          this.apiFailureStatus.storePerformance = true;
          return of(null);
        })
      )
      .subscribe(result => {
        console.log("🚀 ~ AnalyticsReviewFullPageComponent ~ loadStorePerformance ~ result:", result)
        if (result) {
          this.storePerformanceData = {
            salesTotalPerformance: {
              vsTradeAreaSalesAverage: result.salesTotalPerformance?.vsTradeAreaSalesAverage,
              vsBannerMarketSalesAverage: result.salesTotalPerformance?.vsBannerMarketSalesAverage,
              vsMarketSalesAverage: result.salesTotalPerformance?.vsMarketSalesAverage,
              annualSalesTotal: result.salesTotalPerformance?.annualSalesTotal,
              salesTotalGrade: result.salesTotalPerformance?.salesTotalGrade || 'N/A',
              salesIndexScore: result.salesTotalPerformance?.salesIndexScore || 0
            },
            salesPerSqftPerformance: {
              vsTradeAreaSalesPerSqftAverage: result.salesPerSqftPerformance?.vsTradeAreaSalesPerSqftAverage,
              vsBannerMarketSalesPerSqftAverage: result.salesPerSqftPerformance?.vsBannerMarketSalesPerSqftAverage,
              vsMarketSalesPerSqftAverage: result.salesPerSqftPerformance?.vsMarketSalesPerSqftAverage,
              annualSalesPerSqft: result.salesPerSqftPerformance?.annualSalesPerSqft,
              salesPerSqftGrade: result.salesPerSqftPerformance?.salesPerSqftGrade || 'N/A',
              salesPerSqftIndexScore: result.salesPerSqftPerformance?.salesPerSqftIndexScore || 0
            },
            driveTimeMinutes : result?.driveTimeMinutes
          };
          console.log("🚀 ~ AnalyticsReviewFullPageComponent ~ loadStorePerformance ~ this.storePerformanceData:", this.storePerformanceData)
        }
        this.apiCompletionStatus.storePerformance = true;
        this.updateLoadingProgress();
      });
  }

  private loadCompetitiveImpact(forceRefresh: boolean = false): void {
    if (!this.point?.coordinates?.length) {
      this.apiCompletionStatus.competitiveImpact = true;
      this.updateLoadingProgress();
      return;
    }

    const requestBody = {
      point: {
        lat: this.point.coordinates[1],
        lng: this.point.coordinates[0]
      }
    };

    this.assetReviewService.getCompetitiveImpact(this.uuid, requestBody, forceRefresh)
      .pipe(
        catchError(error => {
          console.error('Error fetching competitive impact data:', error);
          this.hasAnalyticsError = true;
          this.apiFailureStatus.competitiveImpact = true;
          return of({});
        })
      )
      .subscribe((result: any) => {
        this.competitiveImpactData = result;
        this.apiCompletionStatus.competitiveImpact = true;
        this.updateLoadingProgress();
        console.log('🚀 Competitive Impact Data:', this.competitiveImpactData);
      });
  }

  private updateLoadingProgress(): void {
    const completedApis = Object.values(this.apiCompletionStatus).filter(status => status).length;

    // Calculate progress: each API is worth 15%, final 10% for completion
    this.analyticsLoadingProgress = Math.min((completedApis / this.totalAnalyticsApis) * 90, 90);

    console.log(`Analytics Progress: ${completedApis}/${this.totalAnalyticsApis} APIs completed (${this.analyticsLoadingProgress}%)`);

    // Check if first 5 APIs are complete to trigger final grade API
    const firstFiveComplete = this.apiCompletionStatus.storeDetails &&
                             this.apiCompletionStatus.realEstate &&
                             this.apiCompletionStatus.bannerStrength &&
                             this.apiCompletionStatus.storePerformance &&
                             this.apiCompletionStatus.competitiveImpact;

    if (firstFiveComplete && !this.apiCompletionStatus.finalGrade && !this.apiFailureStatus.finalGrade) {
      this.loadFinalGrade();
    }

    if (completedApis >= this.totalAnalyticsApis) {
      // Final 10% for completion
      setTimeout(() => {
        this.analyticsLoadingProgress = 100;
        setTimeout(() => {
          this.isAnalyticsLoading = false;
          this.isAnalyticsDataLoading = false;
        }, 300);
      }, 200);
    }
  }

  private loadFinalGrade(): void {
    const currentUuid = this.uuid; // Capture current UUID

    // Validate all required data is for current store before proceeding
    if (!this.validateDataForCurrentStore()) {
      console.log('Data validation failed - not all APIs completed for current store');
      this.apiFailureStatus.finalGrade = true;
      this.hasAnalyticsError = true;
      return;
    }

    // Use score values from API responses directly
    const payload = {
      salesPerSqft: String(this.storePerformanceData?.salesPerSqftPerformance?.salesPerSqftIndexScore || 0),
      totalSales: String(this.storePerformanceData?.salesTotalPerformance?.salesIndexScore || 0),
      realEstateQuality: String(this.realEstateQualityData?.realEstateScore || 0),
      bannerStrength: String(this.bannerStrengthData?.bannerStrengthScore || 0),
      competitiveImpact: String(this.competitiveImpactData?.competitiveImpactScore || 0)
    };

    console.log('Final Grade Payload:', payload);

    this.assetReviewService.getFinalGrade(payload, false)
      .pipe(
        catchError(error => {
          console.error('Error loading final grade:', error);
          // Only update error state if still on same store
          if (this.uuid === currentUuid) {
            this.hasAnalyticsError = true;
            this.apiFailureStatus.finalGrade = true;
          }
          return of(null);
        })
      )
      .subscribe(result => {
        // Only process result if still on the same store
        if (this.uuid === currentUuid) {
          if (result) {
            this.analyticsData.overallGrade = result.overAllGrade;
            console.log('Final Grade Result:', result.overAllGrade);


          }
          this.apiCompletionStatus.finalGrade = true;
          this.updateLoadingProgress();
        }
      });
  }

  private validateDataForCurrentStore(): boolean {
    // Check if all required APIs completed for current store
    return this.apiCompletionStatus.storeDetails &&
           this.apiCompletionStatus.realEstate &&
           this.apiCompletionStatus.bannerStrength &&
           this.apiCompletionStatus.storePerformance &&
           this.apiCompletionStatus.competitiveImpact &&
           this.storePerformanceData &&
           this.realEstateQualityData &&
           this.bannerStrengthData &&
           this.competitiveImpactData &&
           this.assetReviewStoreDetails;
  }




  /**
   * Loads the stored grade and renders the breakdown from it.
   *
   * This is the same record the spotlight card shows, so the page cannot disagree with the
   * card it was opened from. When the page is opened directly by url, or the requested record
   * has aged out of history, it falls back to the current record.
   *
   * Older records were saved before the detail columns existed. Those cannot fill the
   * breakdown, so the page falls back to calculating live, which is what it did previously.
   */
  private loadStoredGrade(): void {
    const currentUuid = this.uuid;

    // Coverage was already checked when the grade was calculated, so this path skips the sales
    // volume verification stage. Marking it complete keeps that loader from showing alongside
    // the report loader.
    this.dataValidation = true;
    this.loadingdataValidation = 100;
    this.isAnalyticsLoading = true;

    // Header is store metadata, not grade data, so it loads either way.
    this.loadAssetReviewStoreDetails(false);

    // refresh=true means the analyst was looking at a freshly generated grade. That was never
    // stored, so the page recalculates rather than trying to recover a snapshot. It costs a few
    // seconds but the url stays self contained, so reloading or sharing it still works.
    const wantsFreshGrade = this.route.snapshot.queryParamMap.get('refresh') === 'true';
    const grade$ = wantsFreshGrade
      ? this.assetReviewService.refreshStoreGrade(this.uuid)
      : this.assetReviewService.getStoreGrade(this.uuid);

    grade$.subscribe({
      next: (response: StoreGradeResponse) => {
        if (this.uuid !== currentUuid) {
          return;
        }
        const record = this.selectGradeRecord(response);
        if (record && record.hasDetail) {
          this.applyGradeRecord(record);
        } else {
          this.fallBackToLiveCalculation();
        }
      },
      error: () => {
        if (this.uuid === currentUuid) {
          this.fallBackToLiveCalculation();
        }
      }
    });
  }

  /**
   * The store details endpoint reports today's date, which is right for a live calculation but
   * wrong for a stored one. Viewing an April record under a header dated today is exactly the
   * mismatch this work exists to remove, so the record's own date wins.
   *
   * Called from both the record and the store details response, since either can arrive last.
   */
  private stampRecordReportDate(): void {
    const calculatedAt = this.gradeRecord?.calculatedAt;
    if (!calculatedAt || !this.assetReviewStoreDetails) {
      return;
    }
    this.assetReviewStoreDetails = {
      ...this.assetReviewStoreDetails,
      reportDate: new Date(calculatedAt).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    };
  }

  /**
   * Hands back to the original live calculation flow, which owns the coverage check and its
   * own loader sequence, so the validation flags are returned to their starting values first.
   */
  private fallBackToLiveCalculation(): void {
    this.dataValidation = false;
    this.loadingdataValidation = 0;
    this.isAnalyticsLoading = false;
    this.loadshapeData();
  }

  /**
   * Picks the record to display from the response.
   *
   * A recordId in the url is matched against the current record and the history, so a shared
   * link opens the same record it was shared from. A record that has aged out of the retained
   * window falls back to the current one rather than showing nothing.
   *
   * On a refresh the response carries the freshly calculated record as current, so there is
   * nothing to match.
   */
  private selectGradeRecord(response: StoreGradeResponse): StoreGradeRecord | null {
    if (!response || !response.hasGrade) {
      return null;
    }

    const requestedId = this.route.snapshot.queryParamMap.get('recordId');
    if (requestedId) {
      const match = [response.current, ...(response.history || [])].find(
        record => record && String(record.recordId) === requestedId
      );
      if (match) {
        return match;
      }
    }
    return response.current;
  }

  private applyGradeRecord(record: StoreGradeRecord): void {
    this.gradeRecord = record;

    const inputs = toAnalyticsPanelInputs(record);
    this.storePerformanceData = inputs.storePerformanceData;
    this.realEstateQualityData = inputs.realEstateQualityData;
    this.bannerStrengthData = inputs.bannerStrengthData;
    this.competitiveImpactData = inputs.competitiveImpactData;
    this.gradeBreakdownData = inputs.gradeBreakdownData;

    if (this.analyticsData) {
      this.analyticsData.overallGrade = record.overall?.grade || 'N/A';
    }

    this.stampRecordReportDate();

    // Nothing is being calculated, so the panel goes straight to its loaded state.
    this.dataValidation = true;
    this.hasAnalyticsError = false;
    this.isAnalyticsLoading = false;
    this.isAnalyticsDataLoading = false;
    this.analyticsLoadingProgress = 100;
    this.loadingdataValidation = 100;
  }

  private resetAllStates(): void {
    // Reset all error and loading states
    this.hasAnalyticsError = false;
    this.dataValidation = false;
    this.isAnalyticsLoading = false;
    this.isAnalyticsDataLoading = false;
    this.analyticsLoadingProgress = 0;
    this.loadingdataValidation = 0;

    // Reset API completion and failure status
    this.apiCompletionStatus = {
      storeDetails: false,
      realEstate: false,
      bannerStrength: false,
      storePerformance: false,
      competitiveImpact: false,
      finalGrade: false
    };
    this.apiFailureStatus = {
      storeDetails: false,
      realEstate: false,
      bannerStrength: false,
      storePerformance: false,
      competitiveImpact: false,
      finalGrade: false
    };

    // Clear analytics data
    this.assetReviewStoreDetails = {};
    this.realEstateQualityData = {};
    this.bannerStrengthData = {};
    this.competitiveImpactData = {};
    this.storePerformanceData = null;
    this.analyticsData = { isLoaded: false };
  }

  private initializeAnalyticsData(): void {
    this.analyticsData = {
      targetName: this.store?.name || null,
      address: this.getFormattedAddress(),
      tradeArea: null,
      reportDate: `${new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`,
      overallGrade:  null,
      totalSalesPerformance: {
        grade: null,
        vsTradeAreaAverage: null,
        vsBannerMarketAverage: null,
        vsMarketAverage: null,
        annualSales: null
      },
      salesPerSquareFoot: {
        grade: null,
        vsTradeAreaAverage: null,
        vsBannerMarketAverage: null,
        vsMarketAverage: null,
        annualSales: null
      },
      realEstateQuality: {
        grade: null,
        access: null,
        parking: null,
        visibility: null,
        trafficFlow: null,
        scCondition: null
      },
      bannerStrength: {
        grade: null,
        creditScore: null,
        networkStability: null,
        marketPresence: null
      },
      competitiveImpact: {
        grade: null,
        competitors: []
      }
    };

    // Initialize store performance data structure
    this.storePerformanceData = {
      salesTotalPerformance: {
        vsTradeAreaSalesAverage: null,
        vsBannerMarketSalesAverage: null,
        vsMarketSalesAverage: null,
        annualSalesTotal: null,
        salesTotalGrade: 'N/A',
        salesIndexScore: 0
      },
      salesPerSqftPerformance: {
        vsTradeAreaSalesPerSqftAverage: null,
        vsBannerMarketSalesPerSqftAverage: null,
        vsMarketSalesPerSqftAverage: null,
        annualSalesPerSqft: null,
        salesPerSqftGrade: 'N/A',
        salesPerSqftIndexScore: 0
      },
      driveTimeMinutes : null
    };

    // Initialize grade breakdown data - only use if API provides data
    this.gradeBreakdownData = {
      sales: 0,
      spsf: 0,
      realEstate: 0,
      banner: 0,
      competitiveImpact: 0
    };
  }

  private getFormattedAddress(): string {
    if (!this.store?.space?.location) {
      return this.assetReviewStoreDetails?.address || null;
    }

    const location = this.store.space.location;
    let address = location.addressLine1 || '';

    if (location.addressLine2) {
      address += `, ${location.addressLine2}`;
    }

    if (location.city) {
      address += `, ${location.city}`;
    }

    if (location.state) {
      address += `, ${location.state}`;
    }

    if (location.postalCode) {
      address += ` ${location.postalCode}`;
    }

    return address || this.assetReviewStoreDetails?.address || null;
  }

  handleDownloadPdf(): void {
    console.log('Download PDF requested - full page');
  }

  handleExportData(format: string): void {
    console.log('Export data requested in format:', format);
  }

  handleAnalyticsExpand(): void {
    this.isExpandedView = !this.isExpandedView;
  }

  handleOpenExternal(): void {
    // Already in full page, no action needed
    console.log('Already in full page mode');
  }

  handleAssetReviewClose(): void {
    // Go back action - for full page, log event (future: navigate to spotlight panel)
    console.log('Go back from full page analytics - future: navigate to spotlight panel');
    // For now, navigate back to map search
    this.router.navigate(['/map-search']);
  }

  handleRetryAnalytics(): void {
    // Retry failed APIs while maintaining successful ones
    this.retryFailedApis();
  }
}
